<template>
  <BaseModal
    :is-open="isOpen"
    :has-vertical-shadow="hasVerticalShadow"
    :has-horizontal-shadow="hasHorizontalShadow"
    v-on="$listeners"
  >
    <template #header>
      <NavBar class="modal-title-navbar" background="none">
        <div slot="center">
          <BaseText class="modal-title" data-testid="modalTitle">
            {{ title }}
          </BaseText>
        </div>
        <div v-if="isLeftCloseIcon" slot="left">
          <CloseButton class="modal-close-button" />
        </div>
        <div v-else slot="right">
          <CloseButton class="modal-close-button" />
        </div>
      </NavBar>
    </template>
    <template #content>
      <div class="modal-content">
        <slot />
      </div>
    </template>
    <template #footer>
      <div class="modal-buttons" data-e2e="modalButtons">
        <slot name="buttons" />
      </div>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { CloseButton } from '@/modules/common/components/buttons';
import { NavBar, BaseText, BaseModal } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    BaseModal,
    CloseButton,
    NavBar,
    BaseText
  }
})
/**
 * @deprecated - use Nebraska Modal instead
 */
export default class Modal extends Vue {
  @Prop({ type: String, required: true, default: '' })
  public title!: string;

  @Prop({ type: Boolean, default: false })
  public isOpen!: boolean;

  @Prop({ type: Boolean, default: true })
  public hasVerticalShadow!: boolean;

  @Prop({ type: Boolean, default: true })
  public hasHorizontalShadow!: boolean;

  @Prop({ type: Boolean, default: true })
  public isLeftCloseIcon!: boolean;

  private created() {
    console.warn('Using deprecated Modal, please use Nebraska Modal instead.');
  }
}
</script>

<style lang="less" scoped>
.modal-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 64px;
  background-color: @background-primary;
}
.modal-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: auto;
  background-color: @background-secondary;
}
.modal-buttons {
  background-color: @background-primary;
  @media screen and (max-width: 640px) {
    flex-direction: column-reverse;
  }

  > button {
    margin: 12px 6px;

    @media screen and (max-width: 640px) {
      margin: 0 !important;
    }
  }
}

.modal-title {
  background-color: @background-secondary;
  color: @text-primary;
  line-height: 14px;
  font-size: 14px;
  font-weight: bold;
}
</style>
